// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4v-5";
export var imageContainer = "_4v-4";
export var metricsGrid = "_4v-2";
export var productDetailContainer = "_4v-1";
export var productListContainer = "_4v-0";
export var subscriberTableContainer = "_4v-3";